import { combineReducers } from 'redux';
import assessment from './ducks/Assessment/reducer';
import global from './ducks/Global/reducer';
import auth from './ducks/Auth/reducer';
import profile from './ducks/Profile/reducer';
import recipes from './ducks/Recipe/reducer';
import measurements from './ducks/Measurements/reducer';
import table from './ducks/Table/reducer';
import admin from './ducks/Admin/reducer';
import suggestic from './ducks/Suggestic/reducer';
import settings from './ducks/Setting/reducer';
import notifications from './ducks/Notifications/reducer';
import todo from './ducks/Todo/reducer';
import nutritionPreference from './ducks/NutritionPreference/reducer';
import guides from './ducks/Guide/reducer';
import exercises from './ducks/Exercise/reducer';
import workouts from './ducks/Workout/reducer';
import workoutProgram from './ducks/WorkoutProgram/reducer';
import workoutPlan from './ducks/WorkoutPlan/reducer';
import carbCycling from './ducks/CarbCycling/reducer';
import equipment from './ducks/Equipment/reducer';
import fitbit from './ducks/Fitbit/reducer';
import adminAssessment from './ducks/AdminAssessment/reducer';
import foodLog from './ducks/FoodLog/reducer';
import adherence from './ducks/Adherence/reducer';
import broadcast from './ducks/Broadcast/reducer';
import checkIn from './ducks/CheckIn/reducer';
import sharedFile from './ducks/SharedFile/reducer';
import ai from './ducks/Ai/reducer';
import challenge from './ducks/Challenge/reducer';

const reducers = combineReducers({
  assessment,
  global,
  auth,
  profile,
  recipes,
  measurements,
  table,
  admin,
  suggestic,
  settings,
  notifications,
  todo,
  nutritionPreference,
  guides,
  exercises,
  workouts,
  workoutProgram,
  workoutPlan,
  carbCycling,
  equipment,
  fitbit,
  adminAssessment,
  foodLog,
  adherence,
  broadcast,
  checkIn,
  sharedFile,
  ai,
  challenge,
});

export default reducers;
